import { Box, useTheme, Typography, IconButton } from "@mui/material"
import { tokens } from "../theme";
import { useState } from "react";

import AddIcon from '@mui/icons-material/AddCircle';
import AddItem from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { getImageUrl, truncate } from "../utils/apiHelpers";

const StoreProduct = ({product, onAddToCart, onRemoveFromCart}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <div>
            <Box display="flex" flexDirection="column" justifyContent="flex-start" sx={{paddingBottom: "20px"}}>
                {
                    product.amount > 0 ? 
                    <Box sx={{position: "absolute", width: "150px", height: "150px" }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        zIndex={1}>
                        <IconButton disableRipple onClick={onRemoveFromCart}>
                            <RemoveIcon sx={{fontSize: "36px"}}/>
                        </IconButton>
                        <Typography
                            variant="h1"
                            color={colors.primary[100]}
                            fontWeight="medium" 
                            fontSize={"60px"}
                            sx={{m : "0 0 0 0" }}
                            >
                            {product.amount}
                        </Typography>
                        <IconButton disableRipple onClick={onAddToCart}>
                            <AddItem sx={{fontSize: "36px"}}/>
                        </IconButton>
                    </Box>
                    : null
                }
                <Box
                    sx={{
                        position: "relative",
                        width: "150px",
                        height: "150px"
                    }}
                >
                    <Box
                        sx={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        borderRadius: 2,
                        border: 4,
                        borderColor: colors.gray[100],
                        }}
                    >
                        {product.image_path !== "" &&
                        <img
                            src={getImageUrl(product.image_path)}
                            width="150px"
                            height="150px"
                            alt="Produktbild"
                            style={{ display: "block", opacity: product.amount === 0 ? 1 : 0.25}}
                        />
                        }
                    </Box>
                    {
                        product.amount === 0 ?
                        <IconButton
                        sx={{
                        position: "absolute",
                        top: -15,
                        right: -15,
                        zIndex: 2,
                        padding: "0px",
                        backgroundColor: colors.gray[900],
                        }}
                        disableRipple
                        onClick={onAddToCart}
                        >
                            <AddIcon sx={{ color: colors.ceriseAccent[100], fontSize: 40 }}/>
                        </IconButton>
                        : null
                    }
                </Box>
                <Typography
                    variant="h4"
                    color={colors.primary[100]}
                    fontWeight="medium" 
                    sx={{m : "5px 0 0px 0px" }}
                    >
                    {truncate(product.name, 18)}
                </Typography>
                <Typography
                    variant="h6"
                    color={colors.ceriseAccent[900]}
                    fontWeight="medium" 
                    sx={{m : "0px 0 5px 0px" }}
                    >
                    {product.price} kr
                </Typography>
            </Box>
        </div>
    )
}

export default StoreProduct